<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="exam"
      :addButtonEntityId="entityId"
      :addButtonEntityType="entityType"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideSearchInput="true"
      @add="showAddModal()"
      @edit="showEditModal($event.id)"
      @delete="showDeleteDialog($event.id)"
    />

    <exam-modal :show="showModal" :id="idToEdit" :isTeam="isTeam" @save="add" @close="hideModal" @update="update" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ComponentTable from '@/components/table/Table';
import ExamModal from '@/components/modals/ExamModal';
import { ExamUnitTypeTranslation } from '@/enums/examUnitType.enum';
import { listMixin } from '@/mixins/list';
import { DEFAULT_TABLE_ACTIONS } from '@/utils/constants';
import { TableName } from '@/enums/tableName.enum';

// @vuese
// Lista egzaminów
// @group Exam
export default {
  mixins: [
    listMixin('exam', {
      listError: 'messages.exam.listError',
      getError: 'messages.exam.getError',
      added: 'messages.exam.added',
      addError: 'messages.exam.addError',
      updated: 'messages.exam.updated',
      updateError: 'messages.exam.updateError',
      deleteConfirm: 'messages.exam.deleteConfirm',
      deleted: 'messages.exam.deleted',
      deleteError: 'messages.exam.deleteError'
    })
  ],
  components: { ComponentTable, ExamModal },
  data() {
    return {
      actions: DEFAULT_TABLE_ACTIONS
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.exam.list.map(exam => ({
          ...exam,
          sportName: exam.sport ? exam.sport.name : 'text.exam.sportGeneral',
          unitName: ExamUnitTypeTranslation[exam.unit]
        }))
    }),
    entityType() {
      return this.$route.params.teamId ? TableName.Team : TableName.Club;
    },
    entityId() {
      return this.$route.params.teamId ? this.$route.params.teamId : this.$route.params.clubId;
    },
    isTeam() {
      return this.entityType === TableName.Team;
    },
    columns() {
      const columns = [
        { name: 'name', displayName: 'columns.name', sortable: true },
        { name: 'unitName', displayName: 'columns.unit', translate: true }
      ];
      if (!this.isTeam) {
        columns.push({ name: 'sportName', displayName: 'columns.sport', translate: true });
      }
      return columns;
    }
  }
};
</script>
